export const BACKGROUND_COLOR_ATTRIBUTE = 'Background Colors';

export const FONTS_ATTRIBUTE = 'Fonts';
